import React from 'react';
import cc from 'classcat';
import C from './InlineList.css';
import { Maybe, MaybeArray } from 'utils/types';

export function InlineList(p: {
  style?: React.CSSProperties;
  className?: string;
  children: MaybeArray<Maybe<React.ReactChild | boolean>>;
}) {
  return (
    <ul className={cc([C.list, p.className])} style={p.style}>
      {p.children}
    </ul>
  );
}
